import { DefaultSubscribe } from './sub-types';
import Off50 from './resources/off-50.png';
import Off33 from './resources/off-33.png';
import Off10 from './resources/off-10.png';
import type { GoodsItem } from './sub-types';
export const formatGoods = (list: any[], defaultCheck: number): GoodsItem[] => {
  if (list.length === 2) {
    const [month1, month12] = list;

    return [
      {
        title: 'Pay annually',
        subtitle: `Billed annually at US$${!month12.isSale ? month12.firstPrice / 100 : month12.price / 100},that’s like`,
        stylizedPricePerMonth: !month12.isSale ? `${Math.floor(month12.firstPrice / 12) / 100}` : `${Math.floor(month12.price / 12) / 100}`,
        formattedBundledPrice: `${(month12.firstPrice / 100).toFixed(2)} USD first year, then ${(month12.price / 100).toFixed(
          2,
        )} USD. Auto-renewable. Cancel anytime.`,
        unit: 'month',
        hasHotFlag: false,
        skuData: month12,
        active: defaultCheck === DefaultSubscribe.FIRST,
        isBestValue: true,
        offSrc: Off50,
        id: DefaultSubscribe.FIRST,
        total: !month12.isSale ? (month12.firstPrice / 100).toFixed(2) : (month12.price / 100).toFixed(2),
      },
      {
        title: 'Pay monthly',
        subtitle: 'Amount billed today',
        stylizedPricePerMonth: !month1.isSale ? `${month1.firstPrice / 100}` : `${month1.price / 100}`,
        formattedBundledPrice: `${(month1.firstPrice / 100).toFixed(2)} USD first month, then ${(month1.price / 100).toFixed(
          2,
        )} USD. Auto-renewable. Cancel anytime.`,
        unit: 'month',
        hasHotFlag: false,
        skuData: month1,
        active: defaultCheck === DefaultSubscribe.SECOND,
        id: DefaultSubscribe.SECOND,
        total: !month1.isSale ? (month1.firstPrice / 100).toFixed(2) : (month1.price / 100).toFixed(2),
      },
    ];
  } else {
    const [month1, month12, day7] = list;

    return [
      {
        title: 'Weekly',
        stylizedPricePerMonth: !day7.isSale ? `${Math.floor(day7.firstPrice) / 100}` : `${Math.floor(day7.price) / 100}`,
        formattedBundledPrice: `${(day7.firstPrice / 100).toFixed(2)} USD first week, then ${(day7.price / 100).toFixed(
          2,
        )} USD. Auto-renewable. Cancel anytime.`,
        unit: 'week',
        hasHotFlag: true,
        isBestValue: true,
        skuData: day7,
        active: defaultCheck === DefaultSubscribe.FIRST,
        offSrc: '',
        id: DefaultSubscribe.FIRST,
        total: !day7.isSale ? (day7.firstPrice / 100).toFixed(2) : (day7.price / 100).toFixed(2),
      },
      {
        title: 'Annually',
        stylizedPricePerMonth: !month12.isSale ? `${Math.floor(month12.firstPrice / 12) / 100}` : `${Math.floor(month12.price / 12) / 100}`,
        formattedBundledPrice: `${(month12.firstPrice / 100).toFixed(2)} USD first year, then ${(month12.price / 100).toFixed(
          2,
        )} USD. Auto-renewable. Cancel anytime.`,
        unit: 'month',
        hasHotFlag: false,
        skuData: month12,
        active: defaultCheck === DefaultSubscribe.SECOND,
        isBestValue: false,
        offSrc: Off50,
        id: DefaultSubscribe.SECOND,
        total: !month12.isSale ? (month12.firstPrice / 100).toFixed(2) : (month12.price / 100).toFixed(2),
      },
      {
        title: 'Month',
        stylizedPricePerMonth: !month1.isSale ? `${month1.firstPrice / 100}` : `${month1.price / 100}`,
        formattedBundledPrice: `${(month1.firstPrice / 100).toFixed(2)} USD first month, then ${(month1.price / 100).toFixed(
          2,
        )} USD. Auto-renewable. Cancel anytime.`,
        unit: 'month',
        hasHotFlag: false,
        isBestValue: false,
        skuData: month1,
        active: defaultCheck === DefaultSubscribe.THIRD,
        offSrc: Off10,
        id: DefaultSubscribe.THIRD,
        total: !month1.isSale ? (month1.firstPrice / 100).toFixed(2) : (month1.price / 100).toFixed(2),
      },
    ];
  }
};
